<scaffold-dialog [size]="'half'" [title]="'Retention Rule'">
  <div scaffoldDialogBody>
    <div>
      <div><label class="data-modal-label">{{'retention_type' | translation}}*</label></div>
      <p-select [(ngModel)]="rule.retentionType" [options]="retentionTypes" optionLabel="name" optionValue="value" required></p-select>
    </div>
    <div>
      <div><label class="data-modal-label">{{'description' | translation}}*</label></div>
      <textarea pTextarea  [(ngModel)]="rule.description" class="date-modal-input-field" fluid></textarea>
    </div>
    <div class="date-modal-range-date-container">
      <div><label class="data-modal-label">{{'effective_date' | translation}}*</label></div>
      <p-datepicker fluid [(ngModel)]="effectiveDate" [showTime]="false" (onSelect)="setDate($event, 'effectiveDate')" appendTo="body" required></p-datepicker>
    </div>
    <div class="date-modal-range-date-container">
      <div><label class="data-modal-label">{{'expiration_date' | translation}}</label></div>
      <p-datepicker fluid [(ngModel)]="expirationDate" [showTime]="false" (onSelect)="setDate($event, 'expirationDate')" appendTo="body"></p-datepicker>
    </div>
    <div>
      <div><label class="data-modal-label">{{'retention_years' | translation}}*</label></div>
      <p-inputnumber [(ngModel)]="rule.retentionPeriod" class="date-modal-input-field" fluid required/>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <button pButton severity="secondary" (click)="close()">{{'close'| translation | transformText : 'uppercase'}}</button>
    <button pButton severity="primary" (click)="save()" [disabled]="hasErrors()|| saving">{{ (rule.id ? 'update' : 'create') | translation | transformText : 'uppercase'}}</button>

  </div>
</scaffold-dialog>